export enum TokenType {
  ERC20 = 'ERC20',
  LP = 'LP',
  ETF = 'ETF',
  ERC721 = 'ERC721',
  ERC721_NATIVE = 'ERC721-NATIVE',
  ERC721_AERODROME_CL = 'ERC721-AERODROME-CL',
  ERC721_AERODROME_CL_GAUGE = 'ERC721-AERODROME-CL-GAUGE',
  ERC721_ALGEBRA = 'ERC721-ALGEBRA',
  ERC721_RAMSES = 'ERC721-RAMSES',
}

export const V3_TOKENS_TYPE = [
  TokenType.ERC721_NATIVE,
  TokenType.ERC721,
  TokenType.ERC721_AERODROME_CL,
  TokenType.ERC721_AERODROME_CL_GAUGE,
  TokenType.ERC721_ALGEBRA,
  TokenType.ERC721_RAMSES,
];
